import React from 'react';
import BackgroundLighter from '../../assets/images/BackgroundLighter.jpg';
import partnerLink from '../../assets/images/icons/link-icon.svg';
import ifood from '../../assets/images/ifood-logo.svg';
import popeyesDelivery from '../../assets/images/popeyes-delivery-logo.svg';
import rappi from '../../assets/images/rappi-logo.svg';
import uber from '../../assets/images/uber-logo.svg';
import { setDeliveryUrl } from '../../utils/deliveryUrl';
import { ContainerDelivery, Content } from './styles';

function DeliveryComponent() {
  return (
    <ContainerDelivery banner={BackgroundLighter}>
      <Content>
        <h1 id="DeliveryComponent">Delivery</h1>
        <p>Escolha o parceiro e peça seu Popeyes de onde estiver</p>

        <div className="partners">
          <a
            href="https://delivery.popeyes.com.br/?utm_source=site-institucional&utm_medium=aba-delivery&utm_campaign=aba-delivery-site-plk"
            id="plk-delivery"
            onClick={() => setDeliveryUrl('plkDelivery')}
          >
            <img
              className="logo"
              src={popeyesDelivery}
              alt="Popeyes Delivery"
            />
            <img className="link" src={partnerLink} alt="Redirect to Partner" />
          </a>

          <a
            href="https://ifoodbr.onelink.me/F4X4/popeyes"
            id="ifood"
            onClick={() => setDeliveryUrl('ifood')}
          >
            <img className="logo" src={ifood} alt="iFood" />
            <img className="link" src={partnerLink} alt="Redirect to Partner" />
          </a>

          <a
            href="https://www.rappi.com.br/restaurantes/900277554"
            id="rappi"
            onClick={() => setDeliveryUrl('rappi')}
          >
            <img className="logo" src={rappi} alt="Rappi" />
            <img className="link" src={partnerLink} alt="Redirect to Partner" />
          </a>
        </div>
      </Content>
    </ContainerDelivery>
  );
}

export default DeliveryComponent;
